<template>
  <div class="sys-ft">
    <div class="sys-main">
      <div class="sys-ft-info">
        <div class="sys-ft-left-wp">
          <div class="sys-ft-intro sys-ft-intro-PC">
            <img class="logo" src="@/assets/shuzhen-logo.png" alt="" />
          </div>
        </div>
        <div class="sys-ft-intro sys-ft-intro-H5">
          <h2>加入数帧云平台</h2>
        </div>
        <div class="sys-ft-nav-wp">
          <dl>
            <dt>产品</dt>
            <dd>
              <a @click.prevent="goFeature(0)">区域化分级管理</a>
            </dd>
            <dd>
              <a @click.prevent="goFeature(1)">实时预警定位</a>
            </dd>
            <dd>
              <a @click.prevent="goFeature(2)">高效能Al调度</a>
            </dd>
            <dd>
              <a @click.prevent="goFeature(3)">系统快速集成</a>
            </dd>
          </dl>
          <dl>
            <dt>平台</dt>
            <dd>
              <a @click.prevent="goSolution(0)">人工智能计算服务中心</a>
            </dd>
            <dd>
              <a @click.prevent="goSolution(1)">人工智能推理中心</a>
            </dd>
            <dd>
              <a @click.prevent="goSolution(2)">人工智能管理中心</a>
            </dd>
          </dl>
          <dl>
            <dt>联系我们</dt>
            <dd>
              <a @click.prevent="goAbout">杭州涞琦科技有限公司</a>
            </dd>
            <dd>
              <a @click.prevent="goAbout">资源合作：4006675066</a>
            </dd>
          </dl>
        </div>
      </div>
      <div class="sys-ft-rights">
        <div style="text-align: center">
          <a href="#" class="first-beian">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAC3FBMVEUAAAD+/ODz6Kr//+PeqFfYrn3x167k0JXoxnyaaVzhs2ifaFXbrGLkvFnpyF7v2X/kwm3cp1nhsGfqw3rZqG3ntVzjrFPt3oDjvGnfr2fbnFGti3q0lH7ktoLryXn9v1T4znr/74bnvGz034v+2I/ktoDz6ZLkwY/Dfz7buoftzYbq2IPr0pjs3bLv6KPRrnbKhFv79ND488n/+dDZr4Lx38f/+cH/95f42oL7/97s2Y3++uzw1rvTk3DmuloAAHkBAm7uzWYAAGXktV3qvFr/0ljksE7fo0rWHxhrdocAAIAABHf143Pyy27w1GwGA2jtymHpwWDqxV/qyVyTeFrrwFflwFPislP+xVLpsErbmUfVkEbysETemUTpgj7ThT3XdTg5FDjdhTXWZTDaTCm7TCbTOCLXPiD9LA/QFg3UAwnOAQOEj5kcPpdyhZSptJEACJFpfo4AG44XMInFvYfTvIejmYSVkINyeoJzdoK9un6SjX7FrnwAEHp8enny2HjWwHjKtnhcX3jYzHeNhnfu2HWUjHWsonPNwnH70m9WTm8AAW//723pym3dtmn/0mbnxGa0o2ZeWWb8zGT/4mPtwmJuYmL/22D/vmB5ZGC9kF7/2l0MAF3uyFqnjVn4xFjYnli0mVi5i1jiqVfyyVbmtlbXkVNUOFPlvFLpt1LNrFKjfVLuvlBgHlDsuU/ouU9ONU/ov05ODk7/2E02Gk3jqkqEaUr/tUngjkf7n0bXikb6xERCJETdn0LckUG1gD/ooD3Ulj3jkz3TZT3WjjzOeDqBWDr3pDnglTlMADnbbTf2gjbkbzaTYDZpAjbplzTtcTTEazPXXzOeXzDscS3MPi38jizJWSrVSCrrXynzfCjVdCjZRyjTQCbFUiTlYCPXPSHLPSHWMR/wXh7iRh7GPh3PLBrSIRrWGhfMJxPGJxPRDBG/ABG2ABCxDg7BDAvEGArZAAbJAALPAADa4ry/AAAAPnRSTlMACEIaxqxpAvv7+ff19PDs7Ovn5uXk5OHg29LRy8fEw8G+vLqysaufnJiVk4yDfG9dXFpMSEFBNTApJyEcFO3QiBQAAAFzSURBVBjTYoACZjYZaTZmBmRgxsp9+di21ZysxggxxlmJZy/ev9LXnriIEa5VYUPIray0lOyd+ctVoKKWXFsmXXvu8exO5vsZnnuErcCC5m1e8x5nPXrxOu3TzSqHFguQmI18tff+Jx89HqR7fE5v7q5TtAYK6h8v81p4Ovv6wbAdmRc6HMpddYGCmudrCqbtTn2anHBq15SZ9iUx6kBBkSTfXIfUuBsPL909c9i/uP6EJFAQMJ6j2/Ps32Yk30uIy3jjXxgRLwEUVN07ubTo5LsPr16mXD1X29gZrgUUlN23uD/H28lp09o5TvYVs523ygEFORYsO+TbEOI5cVVTV+XUA1Fu/EBBoxXu0bfnT98cEePa45oUHR7MBHK9IV9Y/BFHFzc7R7/YqF4BsBiDqVBw0NLQoMAAF3c7vwmCEEFln1ZnZxe3wJWx7nZ2jj5qkNDU5l2/ZE3kusjQuRsDxPXYoQFqa6DBIiUmyqKkYwIWAgD35oZAL/mkFwAAAABJRU5ErkJggg=="
              alt=""
            />
            ©2024 Halo All Rights Reserved 杭州涞琦科技有限公司
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >浙ICP备2026056300号</a
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRoute, useRouter } from "vue-router";
import { onMounted, nextTick } from "vue";
import { useRouterStore } from "@/stores/router";
export default {
  name: "FooterIndex",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const routerStore = useRouterStore();
    const { setRouterName } = routerStore;

    onMounted(() => {
      let dl = document.querySelectorAll(".sys-ft-nav-wp dl");
      for (let i = 0; i < dl.length; i++) {
        dl[i].onclick = function () {
          this.classList.toggle("sys-dl-show");
        };
      }
    });

    const scrollToElement = (hash) => {
      const target = document.querySelector(hash);
      if (!target) {
        return;
      }
      const top = target.getBoundingClientRect().top + window.scrollY - 88;
      window.scrollTo({
        top: Math.max(top, 0),
        behavior: "smooth",
      });
    };

    const goSection = async (hash, query = {}) => {
      const path = `/${hash}`;
      setRouterName(path);

      const sameHash = route.path === "/" && route.hash === hash;
      const sameQuery = Object.entries(query).every(
        ([key, value]) => String(route.query[key] ?? "") === String(value),
      );

      if (sameHash && sameQuery) {
        scrollToElement(hash);
        return;
      }

      await router.push({
        path: "/",
        hash,
        query,
      });

      nextTick(() => {
        scrollToElement(hash);
      });
    };

    const getRouter = (path) => {
      if (path.startsWith("/#")) {
        goSection(path.slice(1));
        return;
      }
      setRouterName(path);
      router.push(path);
    };

    const goFeature = (index) => {
      goSection("#section4", { feature: String(index) });
    };

    const goSolution = (index) => {
      goSection("#section1", { solution: String(index) });
    };

    const goAbout = () => {
      goSection("#section3");
    };

    return {
      router,
      route,
      routerStore,
      getRouter,
      goFeature,
      goSolution,
      goAbout,
    };
  },
};
</script>

<style lang="scss">
.sys-ft {
  position: relative;
  color: #b8c0cc;
  background: #060709;
  padding: 48px 36px 0;
  margin: 0 auto;
  font-size: 14px;
  .sys-main {
    width: min(1440px, 100%);
    padding: 58px 64px 28px;
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    top: 0;
    .sys-ft-left-wp {
      display: flex;
      position: static;
      align-self: start;
      .sys-ft-intro {
        padding-right: 0;
        img {
          width: 150px;
          height: auto;
          display: block;
          margin: 0;
          filter: drop-shadow(0 8px 16px rgba(0, 77, 255, 0.18));
        }
        h2 {
          font-weight: 600;
          font-size: 24px;
          display: inline-block;
          color: #fff;
        }
        p {
          font-size: 14px;
          color: #fff;
          margin-top: 8px;
        }
        a {
          width: 92px;
          height: 28px;
          display: inline-block;
          border-radius: 16px;
          font-size: 14px;
          color: #fff;
          line-height: 24px;
          text-align: center;
          margin-top: 30px;
          text-decoration: none;
          background: linear-gradient(90deg, #0086ff 0%, #0b4bff 69.23%);
        }
        .btn-box {
          cursor: pointer;
          box-sizing: border-box;
          padding: 1px 10px;
          vertical-align: middle;
        }
      }

      .sys-ft-intro-PC {
        display: inline-block;
      }
      .sys-footer-codebox {
        font-size: 13px;
        margin-top: 10px;
        list-style: none;
        .codebox-PC {
          display: inline-block;
          vertical-align: top;
          box-sizing: border-box;
          margin-right: 20px;
          color: #999;
          text-align: center;
          img {
            margin: 0 auto 10px;
            width: 112px;
            height: 112px;
            display: block;
            border: 0;
          }
          p {
            width: 106px;
            height: 18px;
            background: #fff;
            border-radius: 9px;
            font-weight: 400;
            font-size: 12px;
            color: #181a1e;
            margin-left: 3px;
          }
        }
      }
      .sys-footer-codebox li:last-child {
        margin-right: 0;
      }
      .codebox-H5 {
        display: none;
        img {
          margin: 0 auto 10px;
          width: 112px;
          height: 112px;
        }
        p {
          width: 106px;
          height: 18px;
          background: #fff;
          border-radius: 9px;
          font-weight: 400;
          font-size: 12px;
          color: #181a1e;
          margin-left: 3px;
        }
      }
    }
    .sys-ft-info {
      position: relative;
      display: grid;
      grid-template-columns: minmax(140px, 190px) minmax(0, 1fr);
      gap: 56px;
      align-items: start;
      padding-bottom: 34px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      .sys-ft-intro {
        padding-right: 50px;
        h2 {
          font-weight: 600;
          font-size: 24px;
          display: inline-block;
          color: #fff;
        }
        p {
          font-size: 14px;
          color: #fff;
          margin-top: 8px;
        }
        a {
          width: 92px;
          height: 28px;
          display: inline-block;
          background: #fff;
          border-radius: 16px;
          font-size: 14px;
          color: #3b3f46;
          line-height: 24px;
          text-align: center;
          margin-top: 30px;
          text-decoration: none;
        }
        .btn-box {
          vertical-align: middle;
          box-sizing: border-box;
          padding: 1px 10px;
          border: 1px solid #fff;
          cursor: pointer;
        }
      }
      .sys-ft-intro-H5 {
        display: none;
      }
      .sys-ft-nav-wp {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, minmax(140px, 1fr));
        gap: 32px;
        .logo {
          width: 63px;
          height: 63px;
        }
        dl {
          display: block;
          margin: 0;
          line-height: 1.7;
          dt {
            margin-bottom: 16px;
            font-size: 16px;
            letter-spacing: 0.04em;
            color: #fff;
            font-weight: 600;
          }
          dd {
            margin: 0 0 10px;
            font-size: 13px;
            a {
              outline: none;
              text-decoration: none;
              color: #9ea7b3;
              cursor: pointer;
              transition: color 0.2s ease;

              &:hover {
                color: #ffffff;
              }
            }
          }
        }
      }
    }
    // .sys-ft-info::after {
    //   position: absolute;
    //   left: 53%;
    //   top: 8px;
    //   bottom: 0;
    //   width: 1px;
    //   height: 144px;
    //   content: "";
    //   background-color: #444;
    // }
    .sys-ft-rights {
      margin-top: 22px;
      font-size: 12px;
      color: #7e8793;
      display: flex;
      justify-content: center;
      line-height: 1.8;
      a {
        text-decoration: none;
        color: inherit;
        img {
          display: inline-block;
          height: 18px;
          width: 18px;
          vertical-align: text-top;
          margin-right: 3px;
        }
      }

      .first-beian {
        margin-right: 0;
      }
      .last-beian {
        margin-left: 60px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}
// 适配移动端
@media screen and (max-width: 768px) {
  .sys-ft {
    background: #060709;
    background-size: initial;
    min-height: auto;
    min-width: 100%;
    padding: 20px 16px 28px;
    .sys-main {
      width: 100%;
      padding: 28px 0 18px;
      border-radius: 22px;
      top: 0;
      .sys-ft-left-wp {
        display: none;
      }
      .sys-ft-info {
        position: relative;
        display: block;
        padding-bottom: 0;
        margin: 0;
        border: none;
        .sys-ft-intro-H5 {
          display: inline-block;
          text-align: center;
          width: 100%;
          padding: 0 20px 4px;
          .sys-ft-intro h2 {
            font-weight: 600;
            font-size: 24px;
            display: inline-block;
            color: rgb(255, 255, 255);
          }
        }
        .sys-ft-left-wp {
          display: block;
          img {
            display: none;
          }
          .sys-footer-codebox {
            display: flex;
            position: static;
            text-align: center;
            width: 100%;
            margin: 30px auto 10px;
            font-size: 12px;
            padding-left: 20px;
            .codebox-PC {
              display: none;
            }
            .codebox-H5 {
              display: flex;
              background: #fff;
              margin-right: 20px;
              img {
                width: 100px;
                height: 100px;
                margin: 10px 5px;
              }
              p {
                line-height: 14px;
                width: 16px;
                height: 90px;
                background: #fff;
                color: #000;
                border-radius: 9px;
                font-weight: 400;
                font-size: 10px;
                margin-right: 8px;
                margin-top: 24px;
              }
              .codebox-H5-p-black {
                height: 90px;
                background: #000;
                color: #fff;
                margin-right: 4px;
                margin-top: 28px;
              }
            }
          }
        }
        .sys-ft-nav-wp {
          width: auto;
          display: block;
          justify-content: initial;
          position: relative;
          top: 0;
          margin-top: 18px;
          padding-bottom: 8px;
          .logo {
            display: none;
          }
          dl {
            position: relative;
            display: block;
            max-height: 56px;
            height: 56px;
            line-height: 56px;
            overflow: hidden;
            transition: max-height 0.35s ease;
            margin: 0;
            dt {
              position: relative;
              margin-bottom: 0;
              padding: 0 20px;
              font-size: 15px;
              color: #fff;
              font-weight: 600;
            }
            dt:after {
              position: absolute;
              bottom: 0;
              height: 1px;
              content: "";
              background: #cacdd0;
              transform: scaleY(0.5);
              transform-origin: center bottom;
              left: 20px;
              right: 20px;
              background-color: #41444a;
            }
            dd {
              padding: 0 20px;
              background-color: rgba(255, 255, 255, 0.04);
              font-size: 13px;
              margin: 0;
              a {
                color: #b8c0cc;
              }
            }
          }
          dl.sys-dl-show {
            height: auto;
            max-height: 600px;
          }
          dl:before {
            position: absolute;
            right: 20px;
            top: 24px;
            width: 13px;
            height: 1px;
            content: "";
            background-color: #999;
          }
          dl:after {
            position: absolute;
            right: 20px;
            top: 24px;
            width: 13px;
            height: 1px;
            content: "";
            background-color: #999;
            transform: rotate(90deg);
            transition:
              transform 0.3s,
              -webkit-transform 0.3s;
          }
        }
      }
      .sys-ft-rights {
        margin-top: 14px;
        padding: 16px 20px 0;
        text-align: center;
      }
      .sys-ft-info::after {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .sys-ft {
    min-width: 100%;
    padding-left: 24px;
    padding-right: 24px;
    .sys-main {
      width: 100%;
      .sys-ft-info {
        gap: 36px;
        .sys-ft-nav-wp {
          gap: 24px;
        }
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .sys-ft {
    min-width: 100%;
    .sys-main {
      width: 100%;
      .sys-ft-rights {
        div {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
</style>
